import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ams_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---------- Analytics tracking ----------
function getSessionId() {
  let sid = localStorage.getItem("ams_sid");
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("ams_sid", sid);
  }
  return sid;
}

export function trackEvent(type, path = typeof window !== "undefined" ? window.location.pathname : "/") {
  try {
    const body = {
      type,
      path,
      session_id: getSessionId(),
      referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    };
    // Fire-and-forget; don't await, don't throw
    api.post("/analytics/event", body).catch(() => {});
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.debug("[analytics] skipped:", err);
    }
  }
}

export const BRAND = {
  name: "A Mindful Space Counselling",
  short: "A Mindful Space",
  counsellor: "Jesse Winter",
  email: "info@amindfulspacecounselling.com",
  phone: "0492 930 554",
  region: "Tasmania, Australia",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_counsel-book-1/artifacts/yf3ccoy4_New%20Logo%20Better%20quality.png",
  portraitUrl:
    "https://customer-assets.emergentagent.com/job_counsel-book-1/artifacts/1g3zvrtg_Jesse%20Picture.JPG",
  lifestyleUrl:
    "https://customer-assets.emergentagent.com/job_counsel-book-1/artifacts/8l5o7pn9_Try1%20Jesse%20Website%20Picture.JPG",
  natureUrl:
    "https://images.unsplash.com/photo-1648466782276-db180687ea90?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  interiorUrl:
    "https://images.unsplash.com/photo-1673892990360-2168cc2c25d6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
